export default {
  // TODO: Translate (PWA)
  error: {
    trace: 'Traccia: {n}',
    api: {
      response: 'Si è verificato un problema con la risposta del server'
    },
    pin: {
      'INVALID-PIN-LENGTH': 'Il PIN non era della lunghezza corretta',
      'INVALID-PIN': 'È stato fornito un PIN non valido',
      'NO-TRANSACTION-DATA': 'Not Implemented.',
      'NO-ACCOUNT': 'È stato fornito un PIN non valido (Errore: 1)',
      'NO-BRANCH': 'È stato fornito un PIN non valido (Errore: 2)',
      'NO-COMPANY': 'È stato fornito un PIN non valido (Errore: 3)'
    },
    tableNumber: {
      'INVALID-PIN-LENGTH': 'Not Implemented.',
      'INVALID-PIN': 'Not Implemented.',
      'NO-TRANSACTION-DATA': 'Not Implemented.',
      'NO-ACCOUNT': 'Not Implemented.',
      'NO-BRANCH': 'Not Implemented.',
      'NO-COMPANY': 'Not Implemented.'
    }
  }
};